<div class="hmi-pano-layout" [class.karanlik]="karanlikMod">

  <!-- ===== SOL PANEL - HER ZAMAN SABİT ===== -->
  <aside class="hmi-sol-panel" fikoBounceScroll>

    <!-- Dinamik Alan: Reklam / Kişisel -->
    <div class="sol-dinamik-alan">
      @if (nfcDurum === 'tanindi' || nfcDurum === 'giris-anim') {
        <hmi-hizli-erisim [girisSaati]="panoDurum.taninanKisi().girisSaati" [kisiIsim]="panoDurum.taninanKisi().isim" [kisiSoyIsim]="panoDurum.taninanKisi().soyIsim" (tikla)="kisiselTikla($event)"></hmi-hizli-erisim>
      } @else {
        <!-- Reklam / Duyuru Alanı -->
        <div class="reklam-slider">
          @for (r of reklamlar; track r.baslik; let i = $index) {
            <div class="reklam-slide" [class.aktif]="reklamIndex === i"
                 [style.background]="r.bg">
              <div class="reklam-glow"></div>
              <div class="reklam-badge">{{ r.badge }}</div>
              <div class="reklam-hero-ikon">{{ r.ikon }}</div>
              <div class="reklam-icerik">
                <div class="reklam-baslik">{{ r.baslik }}</div>
                <div class="reklam-aciklama">{{ r.aciklama }}</div>
              </div>
              @if (r.cta) {
                <div class="reklam-cta">{{ r.cta }}</div>
              }
            </div>
          }
          <div class="reklam-dots">
            @for (r of reklamlar; track r.baslik; let i = $index) {
              <span class="reklam-dot" [class.aktif]="reklamIndex === i" (click)="reklamIndex = i"></span>
            }
          </div>
        </div>
      }
    </div>

    <!-- NFC Kart Okuyucu Bileşeni -->
    <hmi-kart-okuyucu
      [nfcDurum]="nfcDurum"
      [taninanKisi]="panoDurum.taninanKisi()"
      [nfcApiDestekleniyor]="donanim.nfc"
      (kartOkundu)="onKartOkundu($event)"
      (kartCekildi)="onKartCekildi($event)"
      (durumDegisti)="onNfcDurumDegisti($event)"
      (cikisTiklandi)="sifirla()"
      (testKartKoyuldu)="testKartKoyuldu()"
      (testKartCekildi)="testKartCekildi()"
    ></hmi-kart-okuyucu>

  </aside>

  <!-- ===== SAĞ PANEL - ROUTER OUTLET ===== -->
  <section class="hmi-sag-panel" fikoBounceScroll>
    <router-outlet></router-outlet>
  </section>

</div>
